"use strict";

/**
 * Created by sguilly on 23/08/16.
 */

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("my-formly").run(function (formlyConfig) {
    formlyConfig.setType({
      name: "multiple-items",
      template: '\n                <div class="form-group">\n                <label class=\'control-label\' ng-if=\'to.label\'>{{to.label}}</label>\n\n                      <!-- title on nya-bs-select -->\n                      <ol class="nya-bs-select col-xs-12" ng-model="model[options.key]" actions-box="true" multiple size="10">\n                        <li nya-bs-option="option in to.items">\n                          <a>\n                            {{ option.text }}\n                            <span class="glyphicon glyphicon-ok check-mark"></span>\n                          </a>\n                        </li>\n                      </ol>\n                </div>                    '
    });

    formlyConfig.setType({
      name: "tags",
      template: "\n                <label class='control-label' ng-if='to.label'>{{to.label}}</label>\n                    <tags-input\n                    ng-model='model[options.key]'\n                    ng-attr-placeholder='{{to.placeholder}}'\n                    add-from-autocomplete-only=\"false\"\n                    replace-spaces-with-dashes=\"false\"\n                    >\n                    <auto-complete min-length=\"1\" source='to.tags'></auto-complete></tags-input>\n                    "
    });

    formlyConfig.setType({
      name: "typeahead",
      template: '<input type="text" ng-model="model[options.key]" uib-typeahead="item for item in to.options | filter:$viewValue | limitTo:8" class="form-control">',
      wrapper: ["bootstrapLabel", "bootstrapHasError"]
    });

    var attributes = ["date-disabled", "custom-class", "show-weeks", "starting-day", "init-date", "min-mode", "max-mode", "format-day", "format-month", "format-year", "format-day-header", "format-day-title", "format-month-title", "year-range", "shortcut-propagation", "datepicker-popup", "show-button-bar", "current-text", "clear-text", "close-text", "close-on-date-selection", "datepicker-append-to-body"];

    var bindings = ["datepicker-mode", "min-date", "max-date"];

    var ngModelAttrs = {};

    angular.forEach(attributes, function (attr) {
      ngModelAttrs[camelize(attr)] = {
        attribute: attr
      };
    });

    angular.forEach(bindings, function (binding) {
      ngModelAttrs[camelize(binding)] = {
        bound: binding
      };
    });

    formlyConfig.setType({
      name: "datepicker",
      template: "\n            <p class=\"input-group\">\n                <input  type=\"text\"\n                id=\"{{::id}}\"\n                name=\"{{::id}}\"\n                ng-model=\"model[options.key]\"\n                class=\"form-control\"\n                ng-click=\"datepicker.open($event)\"\n                uib-datepicker-popup=\"{{to.datepickerOptions.format}}\"\n                is-open=\"datepicker.opened\"\n                datepicker-options=\"to.datepickerOptions\" />\n\n                <span>{{model[options.key]}}</span>\n\n                <span class=\"input-group-btn\">\n\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"datepicker.open($event)\" ng-disabled=\"to.disabled\">\n                     <i class=\"glyphicon glyphicon-calendar\"></i>\n                    </button>\n                </span>\n            </p>",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      defaultOptions: {
        ngModelAttrs: ngModelAttrs,
        templateOptions: {
          datepickerOptions: {
            format: "dd.MM.yyyy",
            initDate: new Date()
          }
        }
      },
      controller: ["$scope", function ($scope) {
        $scope.datepicker = {};

        $scope.datepicker.opened = false;

        $scope.datepicker.open = function ($event) {
          $scope.datepicker.opened = !$scope.datepicker.opened;
        };
      }]
    });

    function camelize(string) {
      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : "";
      });
      // Ensure 1st char is always lowercase
      return string.replace(/^([A-Z])/, function (match, chr) {
        return chr ? chr.toLowerCase() : "";
      });
    }

    formlyConfig.setType({
      name: "upload",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      link: function link(scope, el, attrs) {
        el.on("change", function (changeEvent) {
          var file = changeEvent.target.files[0];
          if (file) {
            var fd = new FormData();
            // use key on backEnd
            fd.append("uploadFile", file);
            scope.$emit("fileToUpload", fd);
            var fileProp = {};
            for (var properties in file) {
              if (!angular.isFunction(file[properties])) {
                fileProp[properties] = file[properties];
              }
            }
            scope.fc.$setViewValue(fileProp);
          } else {
            scope.fc.$setViewValue(undefined);
          }
        });
        el.on("focusout", function (focusoutEvent) {
          // dont run validation , user still opening pop up file dialog
          if ($window.document.activeElement.id === scope.id) {
            // so we set it untouched
            scope.$apply(function (scope) {
              scope.fc.$setUntouched();
            });
          } else {
            // element losing focus so we trigger validation
            scope.fc.$validate();
          }
        });
      },
      defaultOptions: {
        templateOptions: {
          type: "file",
          required: true
        }
      }
    });

    // NOTE: This next line is highly recommended. Otherwise Chrome's autocomplete will appear over your options!
    formlyConfig.extras.removeChromeAutoComplete = true;
    // Configure custom types
    formlyConfig.setType({
      name: "ui-select-single",
      extends: "select",
      template: '<ui-select data-ng-model="model[options.key]" data-required="{{to.required}}" data-disabled="{{to.disabled}}" theme="bootstrap">\n        <ui-select-match placeholder="{{to.placeholder}}" data-allow-clear="true">{{$select.selected[to.labelProp]}}</ui-select-match>\n        <ui-select-choices data-repeat="{{to.ngOptions}}">\n          <div ng-bind-html="option[to.labelProp] | highlight: $select.search"></div>\n        </ui-select-choices>\n      </ui-select>'
    });

    formlyConfig.setType({
      name: "nya-bs-select",
      extends: "input",
      template: "\n                <div class=\"flexbox\">\n                    <ol\n                        class=\"nya-bs-select flexbox-full\"\n                        tooltip-placement=\"top\" uib-tooltip=\"{{optionName}}\"\n                        ng-model=\"model[options.key]\"\n                        ng-change=\"onChange()\"\n                        size=\"10\"\n                        data-live-search=\"true\"\n                        disabled=\"options.templateOptions.options.length === 0\"\n                        >\n\n                        <li nya-bs-option=\"option in options.templateOptions.options\" data-value=\"option.value\" title=\"{{option.name}}\">\n                            <a> {{option.name}} </a>\n                        </li>\n                    </ol>\n                    <button tooltip-placement=\"left\" uib-tooltip=\"Effacer la valeur de ce champ\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"reset()\" style=\"margin-left:6px\"><i class=\"fa fa-eraser\"></i></button>\n                    <button ng-if=\"options.templateOptions.createButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"create()\" style=\"margin-left:6px\"><i class=\"fa fa-plus\"></i></button>\n                    <button ng-if=\"model[options.key] && options.templateOptions.editButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"edit()\" style=\"margin-left:6px\"><i class=\"fa fa-edit\"></i></button>\n                    <button ng-if=\"options.templateOptions.refreshButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"refresh()\" style=\"margin-left:6px\"><i class=\"fa fa-refresh\"></i></button>\n                </div>                        ",
      controller: ["$scope", function ($scope) {
        function resetOptionName() {
          var selectedOption = $scope.options.templateOptions.options.find(function (option) {
            return option.value === $scope.model[$scope.options.key];
          });
          if (selectedOption) {
            $scope.optionName = selectedOption.name;
          }
        }

        $scope.refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return $scope.options.templateOptions.refresh();

                case 2:
                  $scope.options.templateOptions.options = _context.sent;

                  resetOptionName();
                  $scope.$applyAsync();

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        $scope.reset = function () {
          $scope.model[$scope.options.key] = null;
          $scope.optionName = "";
          $scope.$applyAsync();
        };

        $scope.onChange = function () {
          console.log("onChange", $scope.model[$scope.options.key]);
          resetOptionName();
        };

        resetOptionName();
      }]
    });

    formlyConfig.setType({
      name: "select-insurer-docs",
      extends: "input",
      template: "<select-insurer-docs id=\"{{options.key}}\" docs=\"model[options.key]\"></select-insurer-docs>"
    });

    formlyConfig.setType({
      name: "button",
      template: "<div style=\"text-align: center; margin-bottom: 10px;\"><button type=\"button\" class=\"btn btn-custom\" ng-click=\"to.onClick()\">{{to.label}}</button></div>"
    });

    formlyConfig.setType({
      name: "rrule",
      template: "<recurring-event style=\"width:600px;\" rule=\"model[options.key]\"></recurring-event>"
    });

    formlyConfig.setType({
      name: "bootstrap-time-picker",
      extends: "input",
      // onkeydown="return false" -> avoid text input
      template: " <time-picker time=\"model[options.key]\" onkeydown=\"return false\"></time-picker>"
    });

    formlyConfig.setType({
      name: "bootstrap-date-picker",
      extends: "input",
      // onkeydown="return false" -> avoid text input
      template: "<bs-date-picker id=\"{{options.key}}\" date=\"model[options.key]\" onkeydown=\"return false\"></bs-date-picker>"
    });

    formlyConfig.setType({
      name: "nya-bs-select-multiple",
      extends: "input",
      template: "\n                <div class=\"flexbox\">\n\n                    <ol\n                        class=\"nya-bs-select flexbox-full\"\n                        tooltip-placement=\"top\" uib-tooltip=\"{{optionName}}\"\n                        ng-model=\"model[options.key || index]\"\n                        ng-change=\"onChange()\"\n                        size=\"10\"\n                        data-live-search=\"true\"\n                        disabled=\"options.templateOptions.options.length === 0\"\n                        multiple\n                        >\n\n                        <li nya-bs-option=\"option in options.templateOptions.options\" data-value=\"option.value\" title=\"{{option.name}}\">\n                            <a> {{option.name}} </a>\n                        </li>\n                    </ol>\n                    <button tooltip-placement=\"left\" uib-tooltip=\"Effacer la valeur de ce champ\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"reset()\" style=\"margin-left:6px\"><i class=\"fa fa-eraser\"></i></button>\n                    <button ng-if=\"options.templateOptions.createButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"create()\" style=\"margin-left:6px\"><i class=\"fa fa-plus\"></i></button>\n                    <button ng-if=\"model[options.key] && options.templateOptions.editButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"edit()\" style=\"margin-left:6px\"><i class=\"fa fa-edit\"></i></button>\n                    <button ng-if=\"options.templateOptions.refreshButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"refresh()\" style=\"margin-left:6px\"><i class=\"fa fa-refresh\"></i></button>\n                </div>                        ",
      controller: ["$scope", function ($scope) {
        function resetOptionName() {
          var selectedOptions = $scope.options.templateOptions.options.filter(function (option) {
            return $scope.model[$scope.options.key || $scope.index].indexOf(option.value) > -1;
          });
          if (selectedOptions.length) {
            $scope.optionName = selectedOptions.map(function (option) {
              return option.name;
            }).join(", ");
          }
        }

        $scope.refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return $scope.options.templateOptions.refresh();

                case 2:
                  $scope.options.templateOptions.options = _context2.sent;

                  resetOptionName();
                  $scope.$applyAsync();

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        $scope.reset = function () {
          $scope.model[$scope.options.key] = null;
          $scope.optionName = "";
          $scope.$applyAsync();
        };

        $scope.onChange = function () {
          console.log("onChange", $scope.model[$scope.options.key]);
          resetOptionName();
        };

        resetOptionName();
      }]
    });

    formlyConfig.setType({
      name: "select-multiple-items",
      extends: "input",
      template: "\n            <div class=\"flexbox\">\n                <ol\n                    class=\"nya-bs-select flexbox-full\"\n                    ng-model=\"selectedItem\" size=\"20\"\n                    data-live-search=\"true\"\n                    disabled=\"options.templateOptions.options.length === 0\">\n                        <li nya-bs-option=\"option in options.templateOptions.options\" data-value=\"option\" title=\"{{option.name}}\">\n                            <a> {{option.name}} </a>\n                        </li>\n                </ol>\n\n                <button type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"add()\" style=\"margin-left:6px\"><i class=\"fa fa-plus\"></i></button>\n            </div>\n                       \n                      \n                            <div class=\"flexbox\" ng-repeat=\"item in listItems\"><div class=\"flexbox-full\">{{item.name}}</div> <button type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"delete($index)\" style=\"margin-left:6px\"><i class=\"fa fa-trash\"></i></button>                   \n                            </div>    \n                       \n                         ",
      controller: ["$scope", function ($scope) {
        $scope.add = function () {
          if (!$scope.listItems) {
            $scope.listItems = [];
          }

          $scope.listItems.push($scope.selectedItem);

          console.log("item=", $scope.selectedItem);

          //$scope.model[$scope.options.key] = docs
        };

        $scope.delete = function (index) {
          console.log("index=", index);

          $scope.listItems.splice(index, 1);
        };
      }]
    });

    formlyConfig.setType({
      name: "bs-switch",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><input\n                        bs-switch\n                        ng-model="model[options.key]"\n                         switch-on-text="Oui"\n                         switch-on-color="success"\n                        switch-off-text="Non"\n                         switch-off-color="warning"\n                        switch-animate="false"\n                        type="checkbox"></div>\n                         ',
      controller: ["$scope", function ($scope) {
        if ($scope.model[$scope.options.key] !== true && $scope.model[$scope.options.key] !== false) {
          $scope.model[$scope.options.key] = false;
        }
      }]
    });

    formlyConfig.setType({
      name: "no-bs-switch",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><input\n                        ng-model="model[options.key]"\n                         switch-on-text="Oui"\n                         switch-on-color="success"\n                        switch-off-text="Non"\n                         switch-off-color="warning"\n                        switch-animate="false"\n                        type="checkbox"></div>\n                         ',
      controller: ["$scope", function ($scope) {
        if ($scope.model[$scope.options.key] !== true && $scope.model[$scope.options.key] !== false) {
          $scope.model[$scope.options.key] = false;
        }
      }]
    });

    formlyConfig.setType({
      name: "select-templates",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><select-templates selected-ids="model[options.key]"></select-templates></div>'
    });

    formlyConfig.setType({
      name: "select-users",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><select-users position="options.templateOptions.position" selected-ids="model[options.key]"></select-users></div>'
    });

    formlyConfig.setType({
      name: "select-groups",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><select-groups selected-ids="model[options.key]"></select-groups></div>'
    });

    formlyConfig.setType({
      name: "select-customers",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><select-customers selected-ids="model[options.key]"></select-customers></div>'
    });

    formlyConfig.setType({
      name: "select-elearnings",
      extends: "input",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      template: '<div class="form-group"><select-elearnings selected-ids="model[options.key]" course-type="model.type"></select-elearnings></div>'
    });

    formlyConfig.setType({
      name: "tags-with-autocomplete",
      extends: "input",
      template: "\n                <div class=\"flexbox\">\n                    <tags-input\n                    class=\"bootstrap flexbox-full\"\n                    ng-model='to.selectedTags'\n                    ng-attr-placeholder='{{to.placeholder}}'\n                    add-from-autocomplete-only=\"false\"\n                    replace-spaces-with-dashes=\"false\"\n                    display-property=\"name\">\n                      <auto-complete min-length=\"1\" source='filter($query)'></auto-complete>\n                    </tags-input>\n\n                    <button ng-if=\"options.templateOptions.createButton === true\" type=\"button\" class=\"btn btn-custom btn-sm\" ng-click=\"create()\" style=\"margin-left:6px\"><i class=\"fa fa-plus\"></i></button>\n                </div>",
      controller: ["$scope", "$q", function ($scope, $q) {
        $scope.filter = function (query) {
          return $q(function (resolve, reject) {
            var filterArray = [];

            for (var index = 0; index < $scope.to.options.length && filterArray.length < 10; index++) {
              var element = $scope.to.options[index];

              if (element.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                filterArray.push({
                  name: element.name,
                  value: element.value
                });
              }
            }

            resolve(filterArray);
          });
        };

        $scope.$watch(function () {
          return $scope.to.selectedTags ? $scope.to.selectedTags.length : 0;
        }, function () {
          //console.log('to.selectedTags', $scope.to.selectedTags)

          if ($scope.to.selectedTags) {
            $scope.model[$scope.options.key] = [];
            for (var index = 0; index < $scope.to.selectedTags.length; index++) {
              $scope.model[$scope.options.key].push($scope.to.selectedTags[index].value);
            }

            //console.log('$scope.model[$scope.options.key]', $scope.model[$scope.options.key])
          }
        });

        $scope.$watch(function () {
          return $scope.model[$scope.options.key];
        }, function () {
          if (!$scope.to.selectedTags && $scope.model[$scope.options.key] && $scope.model[$scope.options.key].length) {
            $scope.to.selectedTags = [];

            // console.log('$scope.to.options', $scope.to.options)

            for (var index = 0; index < $scope.model[$scope.options.key].length; index++) {
              // console.log('$scope.model[$scope.options.key][index]', $scope.model[$scope.options.key][index])

              var elementPos = $scope.to.options.map(function (x) {
                return x.value;
              }).indexOf($scope.model[$scope.options.key][index]);

              console.log("elementPos", elementPos);

              if (elementPos > 0) {
                $scope.to.selectedTags.push({
                  value: $scope.model[$scope.options.key][index],
                  name: $scope.to.options[elementPos].name
                });
              }
            }

            // console.log('$scope.to.selectedTags', $scope.to.selectedTags)
          }
        });
      }]
    });

    formlyConfig.setType({
      name: "edit-docs",
      extends: "input",
      template: "\n            <div id=edit-docs-{{options.key}} class=\"form-group\" ng-click=\"editDocs()\">\n                <button id=edit-docs-{{options.key}} class=\"btn btn-custom\" style=\"width:100%\" >{{model[options.key] ? model[options.key].length : 0}} document(s)</button>\n\n            </div>\n\n            <div class=\"row\">\n              <ng-container ng-repeat=\"doc in model[options.key]\">\n                <div class=\"col-xs-12 col-md-3\" style=\"padding-top: 10px\">\n                    <a href={{doc.url}} target=\"_blank\"><img ng-src=\"{{doc.thumb}}\" height=\"150\" width=\"120\"></img></a>\n                    <b>{{doc.what.name}}</b><br>\n                    {{doc.name.length > 40 ? doc.name.substring(0, 40) + \"...\" : doc.name}} <br>\n                </div>\n              </ng-container>\n\n            </div>\n            ",

      controller: ["$scope", "ModalService", function ($scope, ModalService) {
        var docs = $scope.model[$scope.options.key];

        if (docs) {
          console.log("docs=", $scope.model[$scope.options.key]);

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = $scope.model[$scope.options.key][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var doc = _step.value;

              if (doc.thumb) {
                doc.thumb = doc.thumb.replace(/\+/g, "%2B");
              }

              if (doc.url) {
                doc.url = doc.url.replace(/\+/g, "%2B");
              }

              if (doc.creationDate) {
                doc.creationDate = moment(doc.creationDate).format("DD/MM/YYYY");
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        function getDocKeys(list) {
          if (!Array.isArray(list)) return [];
          return list.map(function (doc) {
            return doc && (doc.url || doc.name || doc.thumb) || null;
          }).filter(Boolean);
        }

        function hasNewDocuments(previousKeys, nextDocs) {
          if (!Array.isArray(nextDocs)) return false;
          var prevSet = new Set(previousKeys);
          return nextDocs.some(function (doc) {
            var key = doc && (doc.url || doc.name || doc.thumb);
            return key && !prevSet.has(key);
          });
        }

        $scope.editDocs = function () {
          console.log("edit docs", $scope);
          var previousKeys = getDocKeys($scope.model[$scope.options.key]);

          ModalService.open("gallery/gallery", {
            docs: $scope.model[$scope.options.key],
            title: $scope.options.templateOptions.label,
            type: $scope.options.templateOptions.type,
            isRestricted: $scope.options.templateOptions.isRestricted
          }).then(function (docs) {
            $scope.model[$scope.options.key] = docs;
          });
        };
      }]
    });

    // Sélecteur de couleur natif ; vide = couleur par défaut de l'écran qui l'affiche.
    formlyConfig.setType({
      name: "color",
      extends: "input",
      template: "<div class=\"formly-color\">\n          <input type=\"color\" class=\"formly-color-input\" ng-model=\"model[options.key]\" ng-disabled=\"options.templateOptions.disabled\">\n          <span class=\"formly-color-value\">{{model[options.key] || \"Par d\xE9faut\"}}</span>\n          <button type=\"button\" class=\"btn btn-white btn-sm\" ng-if=\"model[options.key] && !options.templateOptions.disabled\" ng-click=\"model[options.key] = null\">Par d\xE9faut</button>\n        </div>"
    });

    formlyConfig.setType({
      name: "currency",
      extends: "input",
      template: "<input ng-input-currency class=\"form-control\" ng-model=\"model[options.key]\" type=\"text\" ng-disabled=\"options.templateOptions.disabled\" autocomplete=\"off\" placeholder=\"_ \u20AC\">"
    });

    formlyConfig.setWrapper({
      name: "validation",
      types: ["input"],
      template: "<formly-transclude></formly-transclude>\n          <div ng-messages=\"fc.$error\" ng-if=\"options.validation.errorExistsAndShouldBeVisible\" class=\"error-messages\">\n            <div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=\"control-label has-error\">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div>\n          </div>"
    });

    formlyConfig.setWrapper({
      name: "bootstrapLabel",
      template: ['<label for="{{::id}}" class="control-label">', '{{to.label}} {{to.required ? "*" : ""}}', '<span ng-if="to.tooltip" tooltip-placement="top" uib-tooltip="{{to.tooltip}}"><i class="fa fa-info-circle"></i></span>', "</label>", "<formly-transclude></formly-transclude>", "</div>"].join(" ")
    });

    formlyConfig.setWrapper({
      name: "horizontalBootstrapLabel",
      template: ['<label for="{{::id}}" class="col-sm-2 control-label">', '{{to.label}} {{to.required ? "*" : ""}}', "</label>", '<div class="col-sm-8">', "<formly-transclude></formly-transclude>", "</div>"].join(" ")
    });

    formlyConfig.setWrapper({
      name: "horizontalBootstrapCheckbox",
      template: ['<div class="col-sm-offset-2 col-sm-8">', "<formly-transclude></formly-transclude>", "</div>"].join(" ")
    });

    formlyConfig.setType({
      name: "horizontalInput",
      extends: "input",
      wrapper: ["horizontalBootstrapLabel", "bootstrapHasError"]
    });

    formlyConfig.setType({
      name: "horizontalCheckbox",
      extends: "checkbox",
      wrapper: ["horizontalBootstrapCheckbox", "bootstrapHasError"]
    });
  });
})();